import React from 'react';
import {connect} from 'react-redux';
import Const from 'constants';
import {filterObjectByParams, sortArrayOfObjects} from 'helpers/common-helper';
import {PlayersList as BasePlayersList} from 'components/organisms/used-players-list/components/players-list';
import PlayerExposure from 'components/molecules/player-exposure';
import PlayerLock from 'components/molecules/player-lock';
import PlayerLocksList from 'components/molecules/player-lock/player-locks-list';
import PlayerPoints from 'components/molecules/player-points';
import RankPlayerExclusionState from 'components/molecules/player-exclusion/rank-player-exclusion-state';
import PlayerExposureSummary from 'components/organisms/used-players-list/components/player-exposure-summary';
import TeamLogo from 'components/molecules/team-logo';
import FilterLineupsByPlayerAndMode from 'components/molecules/filter-lineups-by-player/filter-lineups-by-player-and-mode';

class PlayersListComponent extends BasePlayersList {
    getPlayers() {
        const {filters} = this.props;

        const filteredPlayers = this.getFilteredUsedPlayers();

        if (isEmpty(filteredPlayers)) {
            return [];
        }

        let players = [];
        if (Const.OVERALL_MODE === filters.singleGame) {
            let assocList = {};
            filteredPlayers.map((player) => {
                if (!assocList.hasOwnProperty(player.playerId)) {
                    assocList[player.playerId] = {...player};
                    assocList[player.playerId].setAsCaptain();
                } else {
                    assocList[player.playerId].usedLineupsCount += player.usedLineupsCount;
                }
            });
            players = Object.values(assocList);
        } else {
            const searchParams = {
                lineupRole: {
                    filterType: Const.FILTER_TYPE_EQUAL,
                    filterValue: filters.singleGame,
                },
            };
            players = filterObjectByParams(filteredPlayers, searchParams, true);
        }

        return sortArrayOfObjects(players, 'usedLineupsCount', 'desc');
    }

    getActiveMode() {
        const {filters} = this.props;
        if (inArray(filters.singleGame, [Const.OVERALL_MODE, Const.CAPTAIN_MODE])) {
            return filters.singleGame;
        }
        return Const.FLEX_MODE;
    }

    render() {
        const {filters, sportConfig} = this.props;

        const players = this.getPlayers();
        const renderKey = this.getRenderKey();
        const activeMode = this.getActiveMode();

        const items = [];
        if (!isEmpty(players)) {
            Object.values(players).map((player, index) => {
                const className = index % 2 === 0 ? 'even' : '';

                items.push(
                    <tbody key={`${renderKey}${index}`} className={className}>
                        <tr>
                            <td colSpan="5" className="top-line">
                                <RankPlayerExclusionState
                                    activeMode={activeMode}
                                    playerMode={activeMode}
                                    playerId={player.getId()}
                                />
                                <FilterLineupsByPlayerAndMode player={player} activeMode={activeMode} />
                                {super.isRankMode(activeMode) ? (
                                    <PlayerLock
                                        className={`lock-player lock-btn`}
                                        playerId={player.getId()}
                                        mode={activeMode}
                                    />
                                ) : (
                                    <PlayerLocksList playerId={player.getId()} />
                                )}
                                <TeamLogo teamName={player.opponent.toUpperCase()} />
                                <div className="player">
                                    <div>
                                        <div className="name">{player.name}</div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                {this.wrapContentInTooltip(
                                    <PlayerPoints
                                        className="form-control xs-table-input"
                                        playerId={player.getId()}
                                        mode={activeMode}
                                        propName={'userPoints'}
                                    />,
                                    `Default Score: ${player.getPropValueOfMode('adminPoints', activeMode)}`,
                                )}
                            </td>
                            <td className="text-blue">
                                <span className="inline-text">{this.calcPlayerExposure(player)}%</span>(
                                {this.calcPlayerLineupsQuantity(player)})
                            </td>
                            <td>
                                <span>{player.projOwn.getValue()}</span>
                            </td>
                            <td className="td-narrow">
                                <div className="percent-in">
                                    <PlayerExposure
                                        className="form-control small-table-input"
                                        playerId={player.getId()}
                                        propName={'exposureMin'}
                                        mode={activeMode}
                                    />
                                    <span className="percent">%</span>
                                </div>
                            </td>
                            <td className="td-narrow">
                                <div className="percent-in">
                                    <PlayerExposure
                                        className="form-control small-table-input"
                                        playerId={player.getId()}
                                        propName={'exposureMax'}
                                        mode={activeMode}
                                    />
                                    <span className="percent">%</span>
                                </div>
                            </td>
                        </tr>

                        {Const.OVERALL_MODE === filters.singleGame ? (
                            <tr key={`${renderKey}${index}-1`}>
                                <td colSpan="5" className="bottom-line">
                                    <PlayerExposureSummary
                                        site={sportConfig.getSite()}
                                        sport={Const.LEAGUE_MMA}
                                        gameType={sportConfig.getGameType()}
                                        playerId={player.getId()}
                                    />
                                </td>
                            </tr>
                        ) : null}
                    </tbody>,
                );
            });
        } else {
            items.push(this.getTBodyPlayersNotFoundView({colSpan: 4}));
        }

        return (
            <div className="players-used-table table-holder">
                <div className="sticky-table">
                    <table className="players-table">
                        <tbody>
                            <tr>
                                <th>FPts</th>
                                <th>Exp%</th>
                                <th>ProjOwn</th>
                                <th>Exp.min</th>
                                <th>Exp.max</th>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <table className="players-table">{items}</table>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        sportConfig,
        usedPlayers,
        filterLineupsByPlayer,
        lineupsData: {lineups},
    } = state;
    return {
        sportConfig,
        usedPlayers: usedPlayers.players,
        filters: usedPlayers.filters,
        filterLineupsByPlayer,
        lineups,
    };
}

let PlayersList = connect(mapStatesToProps)(PlayersListComponent);

export {PlayersList};
